import { useGetMainList } from "ra-core";
import { FC, createContext, useContext, useMemo } from "react";
import { RecPatch } from "~/dataProvider/tools";
import { SecondaryClassificationResponseDto } from "~/gen/api/governance";
import { FileTagResponseDto } from "~/gen/api/securefile";
import { pages, sorts } from "~/utils/paramsWithGetMainList";
import { SimpleOption } from "../governance/search/AmbientFacilitiesContext";


export interface FileCataAmbientDataContextProps {
  tags: (FileTagResponseDto & RecPatch & SimpleOption)[];
  classifications: (SecondaryClassificationResponseDto & RecPatch & SimpleOption)[];
}

export const FileCataAmbientDataContext = createContext<FileCataAmbientDataContextProps>({} as any)

export const FileCataAmbientDataContextProvider : FC = ({ children }) => {
  const { data: data1, ids: ids1 } = useGetMainList<FileTagResponseDto&RecPatch>('secure-files-tags', pages(), sorts(), {})
  const { data: data2, ids: ids2 } = useGetMainList<SecondaryClassificationResponseDto&RecPatch>('settings/governance/data-classification', pages(), sorts(), {})

  var val = useMemo(() => ({
    tags: (ids1 ?? []).map((id) => {
      const t = data1![id as number]
      const s : SimpleOption = t as any
      s.key = t.tagId!
      s.text = t.name!
      return s as any
    }),
    classifications: (ids2 ?? [])
      .map((id) => {
        const c = data2![id as number]
        const s : SimpleOption = c as any
        s.key = c.secondaryClassificationId!
        s.text = `${c.primaryClassificationText} - ${c.name}`
        return s as any
      })
      .sort((a, b) => 
            ((a.primaryClassification || 0) - (b.primaryClassification || 0)) 
        || ((a.secondaryClassificationId || 0) - (b.secondaryClassificationId || 0))),
  }), [data1, ids1, data2, ids2])
  return (
    <FileCataAmbientDataContext.Provider value={val}>
      {children}
    </FileCataAmbientDataContext.Provider>
  )
}

export const useFileCataAmbientDataContext = () => useContext(FileCataAmbientDataContext);
